<script>
  import { renderable } from './renderable.js';
  import { calcVideoDrawSize } from './video-utils.js';

  export let videoEl;
  export let canDrawVideo = true;
  export let guestStreams = [];
  export let drawGuests = true;

  let bounds = null;

  $: videoEl && calcBounds();

  let boundsTimeout = null;

  const waitForVideoMetadata = () => {
    if (!boundsTimeout) {
      boundsTimeout = setTimeout(() => {
        boundsTimeout = null;
        calcBounds();
      }, 300);
    }
  };

  const calcBounds = () => {
    bounds = calcVideoDrawSize(videoEl);
    if (bounds.sourceWidth < 2) {
      bounds = null;
      waitForVideoMetadata();
    }
  };

  renderable((props) => {
    const { context, width, height } = props;
    if (videoEl && bounds && canDrawVideo) {
      context.drawImage(
        videoEl,
        bounds.sourceX,
        bounds.sourceY,
        bounds.sourceWidth,
        bounds.sourceHeight,
        0,
        0,
        width,
        height,
      );

      if (drawGuests) {
        const targetHeight = height / 3;
        const targetWidth = targetHeight / 1.777777778;
        let y = 20;
        guestStreams.forEach((gs) => {
          if (gs.video.srcObject.active) {
            context.drawImage(
              gs.video,
              gs.sourceX,
              gs.sourceY,
              gs.sourceWidth,
              gs.sourceHeight,
              20,
              y,
              targetWidth,
              targetHeight,
            );
            y += targetHeight + 20;
          }
        });
      }
    } else {
      context.clearRect(0, 0, width, height);
    }
  });
</script>

<!-- The following allows this component to nest children -->
<slot />
